import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FLAGS } from '../config/flags';
import { FadeLoader } from 'react-spinners';

const DerivGuard = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <FadeLoader color="#4ade80" />
      </div>
    );
  }

  // If gate is relaxed, let everyone through
  if (FLAGS.RELAX_DERIV_GATE) {
    return <Outlet />;
  }

  // If user exists but hasn't linked Deriv, redirect to linking page
  const isLinked = user?.deriv_linked === true;

  if (!isLinked) {
    return <Navigate to="/link-deriv" replace />;
  }

  // New: If linked but not onboarded, force onboarding
  if (!user?.is_onboarded) {
    return <Navigate to="/onboarding" replace />;
  }

  return <Outlet />;
};

export default DerivGuard;
